<template>
  <div class="article-detail-container">
   
    <!-- 内容展示 -->
    <div class="mainbodyyy menus" v-scroll-animate="'slide-itemgk'" style="width: 90vw; margin:0 auto">
          <a href="/home"><i class="el-icon-s-home"></i></a> / <a @click="backParent()">信息公开</a> / 企务公开  
      
          <span class="fontsizeCssy">字体 【 <em @click="fontsize='big'">大</em> <em @click="fontsize='default'">中</em> <em @click="fontsize='small'">小</em> 】</span>

        </div>
    <div  class="articleDetailDiv" >
     
            <h1 v-scroll-animate="'fly-in-bottomgy'" class="fontSizeTitle">{{ article.title }}</h1>
            <p class="fontcssxy0" v-scroll-animate="'fly-in-bottomgy'">发布时间：{{ article.createDate }}   点击量：{{ article.hits }}</p>
            <div :class="this.fontsize=='big'?'contentcss0 contentcss0big':this.fontsize=='small'?'contentcss0 contentcss0small':'contentcss0'" v-blank-link v-html="article.content"  v-scroll-animate="'fly-in-bottomgy'"></div>

             <!-- 新增上下篇导航 -->
            <!-- 新增上下篇导航 -->
    <div class="detail-pagination">
  <div class="pagination-bg">
    <div class="prev-article">
  <span class="pagination-label">上一篇：</span>
  <template v-if="prevArticle">
    <a @click="godetail" class="article-title">{{ prevArticle.title }}</a>
  </template>
  <span v-else class="no-article">没有了</span>
</div>
<div class="next-article">
  <span class="pagination-label">下一篇：</span>
  <template v-if="nextArticle">
    <a @click="godetail1" class="article-title">{{ nextArticle.title }}</a>
  </template>
  <span v-else class="no-article">没有了</span>
</div>
  </div>
</div>
    </div>


     
      

     
    </div>
</template>

<script>
import PCNavbar from '@/components/navbar/index'
import MobileNavBar from '@/components/navbar/MobileNavBar.vue'
import API from '@/api/bsInfo'

export default {
  props: {
    nowObj: Object,
    articles:Array,
    indexNum:Number
  },
  data() {
    return {
      fontsize:'default',
      article: null,
      loading: true,
      error: false,
      nowTab:null,
      preObj:{},
      nextObj:{}
    }
  },
  components: {
    PCNavbar,
    MobileNavBar
  },
  computed: {
    processedContent() {
      if (!this.article?.content) return ''
      return this.article.content
        .replace(/style="[^"]*"/g, '')  
        .replace(/<p>/g, '<p class="compact-paragraph">') 
        .replace(/<br\/?>/g, '<br class="compact-break">') 
    },
  
    prevArticle() {
    return this.indexNum > 0 ? this.articles[this.indexNum - 1] : null;
  },
  nextArticle() {
    return this.indexNum < this.articles.length - 1 ? this.articles[this.indexNum + 1] : null;
  }
  },
  created() {
    
    console.log(this.indexNum)
    this.fetchArticle()
  },
  watch: {
  '$route.query.artId'(newVal) {
    this.indexNum = parseInt(this.$route.query.index) || 0;
    this.fetchArticle();
  }
},
mounted() {
  
  },
  methods: {
  
    
    godetail() {
    if (this.prevArticle) {
      this.indexNum--;
      this.updateCurrentArticle();
    }
  },
  godetail1() {
    if (this.nextArticle) {
      this.indexNum++;
      this.updateCurrentArticle();
    }
  },
  updateCurrentArticle() {
    this.nowObj = this.articles[this.indexNum];
    this.fetchArticle();
    // 同步更新路由参数（如果使用vue-router）
    this.$router.push({ 
      query: { 
        artId: this.nowObj.id,
        index: this.indexNum 
      }
    });
  },
    backParent(){
      this.$parent.cengji=1
      // this.changeCengji0()
    },
    changeCengji0(){
      
      this.$emit('changeCenggji0')
    },
    // 获取文章详情
    async fetchArticle() {
      try {
        this.loading = true
        this.error = false
        
        const artId = this.nowObj.id
        if (!artId) throw new Error('缺少文章ID')

        const res = await API.getArticleData({ artId })
        
        
        const targetArticle = res?.data?.list?.find(item => item.id === artId)
        if (!targetArticle) throw new Error('文章不存在')

        this.article = {
          ...targetArticle,
          
          createDate: targetArticle.createDate || '未知日期',
          hits: targetArticle.hits || 0,
          nowTab:targetArticle.name
        }
       // 回到顶部
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
      } catch (error) {
        console.error('文章加载失败:', error)
        this.error = true
        // 异常情况加载默认数据
        this.loadFallbackData()
      } finally {
        this.loading = false
      }
    },

    

    // 加载备用数据
    loadFallbackData() {
      this.article = {
        title: "文章加载中",
        createDate: new Date().toISOString(),
        content: "<p>正在获取最新内容，请稍候...</p>",
        hits: 0
      }
    },

    // 
    retryFetch() {
      this.article = null
      this.fetchArticle()
    }
  }
}
</script>

<style lang="scss" scoped>
.detail-pagination {
    width: 80vw;
    margin: 2rem auto 0;
    padding: 1rem 0;
    border-top: 1px solid #eee;
  
    .pagination-bg {
      background: #f8f8f8;
      padding: 1.2rem;
      border-radius: 4px;
    }
  
    .prev-article, .next-article {
      line-height: 1.8;
      font-size: 0.95rem;
      
      + .next-article {
        margin-top: 0.8rem;
      }
    }
  
    .pagination-label {
      color: #999;
      margin-right: 0.5rem;
    }
  
    .article-title {
      color: #333;
      cursor: pointer;
      transition: color 0.3s;
  
      &:hover {
        color: #2091d3;
        text-decoration: underline;
      }
    }
  
    .no-article {
      color: #999;
    }
  }
.mainbody{
  width: 100%;
  background:#ffffff;
 }
 .mainbodyyy{
  width: 100%;

 }
//  .menus{
//   padding:1rem;
//   padding-left: 0;
//   font-size:1rem;
//  }
 .articleDetailDiv{
  width: 90vw;
    margin: 0 auto;
    padding:0 70px 50px;
    border:  1px solid #e5e5e5;
  margin-bottom: 1rem;
  
  h1{
    width: 80%;
    margin:0 auto;
    margin-bottom: 1rem;
    border-bottom: 1px solid #999999;
    text-align: center;
    padding:1rem 0;
  }
  p{
    text-align: center;
  }
  div.contentcss0{
      margin: 0 auto;
      margin-top: 1rem;
      @media screen and (max-width:768px) {
        *{
          font-size: 0.5rem !important;
        }
     }
       
    }
    // 重置字体样式001
    div.contentcss0 :not(.keep-style) {
      // width: 90%;
      margin: 0 auto !important;
      // margin-top: 1rem;
      font-size:1rem !important;
      line-height: 2em !important;
      text-indent:2rem !important;
    //  text-align: left !important;
      @media (min-width: 0px) and (max-width: 991px) {
      span img{
          margin-left: -28px!important;
        }
      }
    }
}

 // 重置图片样式 002
 div.contentcss0  img {
    border: var(--img-border, none) !important;
    width: var(--img-width, auto) !important;
    height: var(--img-height, auto) !important;
  }

  /* 使用深度选择器（Vue 2/3 兼容写法） */
  .contentcss0 >>> img,.contentcss0 ::v-deep img,.contentcss0 :deep(img) {
    border: none !important; /* 移除边框 */
    padding: 0 !important;
    // margin: 0!important;
    box-shadow: none !important;
    display: block;
    margin:0 auto !important;
    width: 60% !important;
  }

  .contentcss0 >>> table,.contentcss0 ::v-deep table,.contentcss0 :deep(table) {
    
    margin:0 auto !important;
    width: 80% !important;
  }
  .top-bg {
    width:100%;
  margin-top:100px;
  height:auto;
  }
.preNextDiv{
  width: 90%;
    margin: 2rem auto 0;
    padding: 1rem 0;
    border-top: 1px solid #eee;
    div{
      background: #f8f8f8;
      padding: 1.2rem;
      border-radius: 4px;
      color: #333;
      cursor: pointer;
      transition: color 0.3s;
      line-height: 1.8;
      font-size: 0.95rem;
      a:hover{
        text-decoration: underline;
      }
    }

}
.articleDetailDiv {
    div.contentcss0big :not(.keep-style) {
        font-size: 1.1rem !important;
    }

    div.contentcss0small :not(.keep-style) {
        font-size: 0.9rem !important;
    }
}
</style>